export const TractionSystemKeys = {
  fDriveForceAx3And4Total: 'fDriveForceAx3And4Total',
  forceAppliedAx3And4total: 'forceAppliedAx3And4total',
  edBrakeForce: 'edBrakeForce',
  VLimit: 'VLimit',
  tractionNullZeroTorque: 'tractionNullZeroTorque',
  wheelCapInfoCheck: 'wheelCapInfoCheck',
  isCouplingProcessCompleted: 'isCouplingProcessCompleted',
  isDecouplingDone: 'isDecouplingDone',
  ASCActive: 'ASCActive',
  tractionInhibited: 'tractionInhibited',
  maximumSpeedExceeded: 'maximumSpeedExceeded',
  openingError: 'openingError',
  tkysCerCommunicationError: 'tkysCerCommunicationError',
  tcuVacuumCommandBypass: 'tcuVacuumCommandBypass',
  sprayEnabled: 'sprayEnabled',
  zeroSpeedBypass: 'zeroSpeedBypass',
  forceAvmAx3: 'forceAvmAx3',
  forceAvmAx4: 'forceAvmAx4',
  forceAppliedAx3: 'forceAppliedAx3',
  forceAppliedAx4: 'forceAppliedAx4',
  velMotorAx3: 'velMotorAx3',
  velMotorAx4: 'velMotorAx4',
  tempMotorAx3: 'tempMotorAx3',
  tempMotorAx4: 'tempMotorAx4',
  contactorMotorCooling1Inserted: 'contactorMotorCooling1Inserted',
  contactorMotorCooling2Inserted: 'contactorMotorCooling2Inserted',
  flowDetectorDuct1: 'flowDetectorDuct1',
  flowDetectorDuct2: 'flowDetectorDuct2',
  tempTrcIn1: 'tempTrcIn1',
  tempTrcIn2: 'tempTrcIn2',
  tempTrcRec: 'tempTrcRec',
  isolationMonitoringFault: 'isolationMonitoringFault',
  failureTcu: 'failureTcu',
  lcuOk: 'lcuOk',
  cutOffTraction: 'cutOffTraction',
  failureTransformer: 'failureTransformer',
  cutOffBypass: 'cutOffBypass',
  lcuMaintenance1: 'lcuMaintenance1',
  lcuMaintenance2: 'lcuMaintenance2',
  sMotorAx3: 'sMotorAx3',
  sMotorAx4: 'sMotorAx4',
  motor1CoolingFault: 'motor1CoolingFault',
  motor2CoolingFault: 'motor2CoolingFault',
  sInvAx3: 'sInvAx3',
  sInvAx4: 'sInvAx4',
  sTractionRectifierL1Ok: 'sTractionRectifierL1Ok',
  sTractionRectifierL2Ok: 'sTractionRectifierL2Ok'
} as const;
